(function () {
    'use strict';

    angular
        .module('app')
        .factory('DocMergeService', DocMergeService);

    DocMergeService.$inject = ['$http', 'UrlService', 'Upload'];

    /**
     * @param {Object} Upload - ngFileUpload service
     */
    function DocMergeService($http, UrlService, Upload) {

        var service = {
            testMerge: testMerge,
            merge: merge
        };

        return service;

        /**
         * @param {Number} entityId
         * @param {Number} documentTemplateId
         * @param {String} outputFormat
         * @param {String} activityDescription
         * @param {String} fileDescription
         * @param {String} fileName
         * @param {Array} tags
         * @param {bool} saveToCurrentEntity
         * @param {bool} saveToCurrentUser
         * @param {bool} saveToOrganisation
         * @param {bool} saveToEntities
         */
        function merge(entityId, documentTemplateId, outputFormat, activityDescription, fileDescription, fileName, tags, saveToCurrentEntity,
                        saveToCurrentUser, saveToOrganisation, saveToEntities) {
            var mergeRequest = {
                EntityId: entityId,
                DocumentTemplateId: documentTemplateId,
                OutputFormat: outputFormat,
                ActivityDescription: activityDescription,
                FileDescription: fileDescription,
                FileName: fileName,
                Tags: tags,
                SaveToCurrentEntity: saveToCurrentEntity,
                SaveToCurrentUser: saveToCurrentUser,
                SaveToOrganisation: saveToOrganisation,
                SaveToEntities: saveToEntities
            };

            return $http.post(
                UrlService.getWebAPIUrl() + '/DocumentMerge/MergeDocumentTemplate',
                mergeRequest)
                .then(function ok(response) {
                    return response.data;
                });
        }

        /**
         * @param {Number} entityId - If null or undefined, random test data will be used
         * @param {Blob} documentTemplate - A Blob object for the document template
         * @param {String} templateFormat - E.g. docx, pdf
         * @param {String} outputFormat - E.g. docx, pdf
         * @param {Object} advancedTemplateSettings - Advanced template settings in the same format as C# object: ChilliDocs.Models.DocumentTemplate.DocumentTemplateAdvancedSettings
         * @param {String} fileName - File name defined for merge result
         * @param {Object} documentTemplateMergeFields - Data for the document template in the same format as C# object: ChilliDocs.Models.DocumentTemplate.DocumentTemplateMergeFields.
         *
         * @returns {Promise} A promise that resolves once the test merge completes. Resolves with a object having 'FileName' and 'Data' properties. 'Data' can either be a String or ArrayBuffer, depending on the output format.
         *   HTML and TXT are String formats, others are ArrayBuffer.
         */
        function testMerge(entityId, documentTemplate, templateFormat, outputFormat, advancedTemplateSettings, fileName, documentTemplateMergeFields) {
            var mergeRequest = {
                EntityId: entityId,
                DocumentTemplateFormat: templateFormat,
                OutputFormat: outputFormat,
                AdvancedTemplateSettings: advancedTemplateSettings,
                FileName: fileName,
                DocumentTemplateMergeFields: documentTemplateMergeFields
            };

            var uploadRequest = {
                url: UrlService.getWebAPIUrl() + '/DocumentMerge/MergeDocumentTemplateTest',
                data: {
                    files: {
                        template: documentTemplate
                    },
                    jsonData: angular.toJson(mergeRequest)
                },
                method: 'POST'
            };

            // text and html are string/text formats, others we'll assume binary is preferred
            // setting responseType to 'arrayBuffer' will return that type, otherwise the response data will be a string
            if (outputFormat.toLowerCase() !== 'html' && outputFormat.toLowerCase() !== 'txt') {
                uploadRequest.responseType = 'arraybuffer';
            }

            return Upload.upload(uploadRequest)
                .then(function (response) {
                    return {
                        Data: response.data,
                        FileName: (/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(response.headers('Content-Disposition'))[1]).replace(/"/g, '')
                    };
                });
        }
    }
})();